import { styled } from '@mui/material/styles';

/** close-guard 모달 본문/푸터 styled — 셸은 포탈 표준 Modal 재사용 */

export const ConfirmMessage = styled('p')`
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
  color: var(--dk-text, #1d2025);
  /* "작성중인 코멘트가 있습니다.\n화면을 닫으시겠어요?" 의 줄바꿈 보존 */
  white-space: pre-line;
`;

export const ConfirmFooter = styled('div')`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
